import { ActionIcon, ActionIconProps } from "@mantine/core";

const defaultActionIconProps: ActionIconProps = {
  size: "md",
};

interface EbActionIconProps extends ActionIconProps {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const EbActionIcon: React.FC<EbActionIconProps> = ({
  children,
  ...props
}) => {
  const mergedProps = { ...defaultActionIconProps, ...props };
  return (
    <ActionIcon
      component="a"
      {...mergedProps} // Apply all merged props
      onClick={(event) => {
        event.preventDefault();
        if (mergedProps.disabled) return;
        props.onClick(event);
      }}
    >
      {children}
    </ActionIcon>
  );
};

// Optional: Give it a display name for easier debugging in React Dev Tools
EbActionIcon.displayName = "EbActionIcon";
